import { render, staticRenderFns } from "./InspectionInspectedStatusBadge.vue?vue&type=template&id=654bf102&scoped=true"
import script from "./InspectionInspectedStatusBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectionInspectedStatusBadge.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InspectionInspectedStatusBadge.vue?vue&type=style&index=0&id=654bf102&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654bf102",
  null
  
)

export default component.exports